import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4a43b155&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=4a43b155&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a43b155",
  null
  
)

export default component.exports